import type { EmojiData } from './types';

export function isValidData(value: unknown): value is EmojiData {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.group === 'string' &&
    typeof v.id === 'string' &&
    (v.variant === 'default' || v.variant === 'stamp')
  );
}
